"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTagString = exports.TagType = void 0;
const zod_1 = require("zod");
var TagType;
(function (TagType) {
    TagType["Inquiry"] = "inquiry";
})(TagType = exports.TagType || (exports.TagType = {}));
exports.parseTagString = zod_1.z
    .string()
    .min(3, 'A tag deve conter pelo menos 3 caracteres')
    .max(50, 'A tag deve conter no máximo 50 caracteres');
